<template>
  <slider v-if="slides.length > 0" :slides="slides" :image-width="imageWidth" :image-height="imageHeight" effect="fade" :navigation="false" />
</template>

<script setup lang="ts">
import { type Slide } from '@/types/swiper';
import slider from '@/js/components/common/ui/slider.vue';

const props = defineProps<{
  slidesJson: string;
  imageWidth: number;
  imageHeight: number;
}>();
const slides: Slide[] = JSON.parse(props.slidesJson);
</script>
